import React, { useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../utils";
import { Tag } from "antd";
import Actions from "../../antd/Table/Actions";
import AntdTable from "../../antd/Table/Table";
import { useGetAllPOIsQuery } from "../../../Redux/service/POIS/POIs";
import { filtrationcontext } from "../../../context/Filtercontext";
import { capitalize } from "lodash";
import { popupcontext } from "../../../context/Popupscontext";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import usePermission from "../../../hooks/usePermission";

export default function POIstable({
	queryString,
	currentPage,
	setCurrentPage,
}) {
	const {
		handleShow,
		setEdited,
		deleteItem,
		setDeleteItem,
		reloadData,
		setReloadData,
	} = useContext(popupcontext);
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});

	const {
		data: ListPOISdata,
		isLoading,
		refetch,
	} = useGetAllPOIsQuery(
		{
			page: currentPage,
			limit: limit,
			status: "true",
			search: searchQuery,
			sortby: sort.by,
			sortorder: sort.order,
			queryString: queryString,
		},
		{
			skip: !currentPage || !limit,
			refetchOnMountOrArgChange: true,
		}
	);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);

	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "pois") {
			refetch();
			if (ListPOISdata?.data.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		ListPOISdata?.data,
	]);
	useEffect(() => {
		if (reloadData) {
			refetch();
			setReloadData(false);
		}
	});
	const { create, edit, delete: canDelete } = usePermission("POIS");

	const POIsColumn = [
		{
			title: trans("POI Name"),
			dataIndex: "name",
			width: 200,
			sorter: true,
			fixed: !isRTL ? "left" : undefined,
			render: (name) => (
				<span className={"table-element-name ps-0"}>{name}</span>
			),
		},
		{
			title: trans("Code"),
			dataIndex: "code",
			width: 150,
			render: (code) => <span>{code ? code : "- - - - -"}</span>,
		},
		{
			title: trans("Type"),
			dataIndex: "type",
			fixed: !isRTL ? "left" : undefined,
			sorter: true,
			width: 150,
			capitalize,
		},
		{
			title: trans("Status"),
			dataIndex: "status",
			width: 150,
			render: (status) => (
				<Tag color={status ? "green" : "default"}>
					{status ? trans("Active") : trans("Inactive")}
				</Tag>
			),
		},
		{
			title: trans("Address"),
			dataIndex: "address",
			width: 150,
			render: (address) => <span>{address ? address : "- - - - -"}</span>,
		},
		{
			title: trans("State"),
			dataIndex: "state",
			sorter: true,
			width: 150,
			render: (state) => <span>{state ? state : "- - - - -"}</span>,
		},
		{
			title: trans("City"),
			dataIndex: "city",
			sorter: true,
			width: 150,
		},

		{
			title: trans("Geofenced"),
			dataIndex: "geofenced",
			width: 150,
			render: (geofenced) => (
				<Tag color={!geofenced ? "default" : "green"}>
					{!geofenced ? trans("Disabled") : trans("Enabled")}
				</Tag>
			),
		},
		{
			title: trans("Created At"),
			dataIndex: "createdAt",
			sorter: true,
			width: 150,
			render: (createdAt) => <span>{formatDateString(createdAt)}</span>,
		},

		{
			title: trans("Actions"),
			width: 150,
			fixed: !isRTL ? "right" : undefined,
			render: ({ id }) => (
				<Actions
					poiId={id}
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];
	return (
		<>
			<div className="bg-white-rounded-top mt-3 table-parent">
				<AntdTable
					columns={POIsColumn}
					loading={isLoading}
					dataSource={ListPOISdata?.data || []}
					pageSize={limit}
					totalItems={ListPOISdata?.totalResults || 0} // Total count for pagination
					currentPage={currentPage}
					onPageChange={(page) => setCurrentPage(page)}
					onLimitChange={(newLimit) => {
						setLimit(newLimit);
						setCurrentPage(1);
					}}
					onTableChange={handleTableChange}
				/>
			</div>
		</>
	);
}
